import { TkitUtils as Utils } from '@tkit/types';
import createModel, { Tction } from '@tkit/model';
import upperFirst from 'lodash/upperFirst';
import produce from 'immer';

import { IRootState, ListPane } from '@src/types';
import {
  APIS,
  BannerVO,
  HotGroupOrTeamEntity,
  CommonResult,
  ClassifyInfo,
  ParamsarticleInterestBussinessIdUsingPost,
  ParamshomeArticlesUsingGet,
  ParamssubjectsListUsingGet
} from '@src/services';

import {
  PAGE_SIZE,
  LIST_INITIAL,
  NETWORK_ERROR_TIP,
  THEMATIC_PAGE_SIZE
} from '@src/utils/constant/common';
import {
  HOME_NAV_KEY_ARTICLE,
  HOME_NAV_KEY_ASK,
  HOME_TAB_KEY_LATEST,
  HOME_TAB_KEY_LATEST_QUESTION,
  HOME_TAB_KEY_LATEST_ANSWER,
  HOME_TAB_KEY_VOTE,
  HOME_ANSWER_AGREE_ACTION_TYPE,
  HOME_ANSWER_DISAGREE_ACTION_TYPE,
  HOME_TAB_KEY_FOLLOW,
  HOME_TAB_KEY_HOT_QUESTION,
  HOME_TAB_KEY_HOT,
  HOME_TAB_KEY_THEMATIC
} from '@src/utils/constant/home';

import { message } from 'antd';
export interface HomeBaseNav {
  banner: ListPane<BannerVO>;
  follow: ListPane<any>;
}

export interface HomeModelState {
  article: HomeBaseNav & {
    latest: ListPane<any>;
    hot: ListPane<any>;
    preRelease: ListPane<any>;
    thematic: ListPane<any>;
  };
  ask: HomeBaseNav & {
    latestQuestion: ListPane<any>;
    latestAnswer: ListPane<any>;
    hotQuestion: ListPane<any>;
    vote: ListPane<any>;
  };

  /** 热门圈子 */
  groupList: HotGroupOrTeamEntity[];
  /** 热门团队 */
  teamList: HotGroupOrTeamEntity[];
  /** 文章分类列表 */
  classifyAll: ClassifyInfo[];
  unReadArticle: number;
}

export const homeModelState: HomeModelState = {
  article: {
    banner: LIST_INITIAL,
    hot: LIST_INITIAL,
    follow: LIST_INITIAL,
    latest: LIST_INITIAL,
    preRelease: LIST_INITIAL,
    thematic: LIST_INITIAL
  },
  ask: {
    banner: LIST_INITIAL,
    follow: LIST_INITIAL,
    hotQuestion: LIST_INITIAL,
    latestQuestion: LIST_INITIAL,
    latestAnswer: LIST_INITIAL,
    vote: LIST_INITIAL
  },
  groupList: [],
  teamList: [],
  classifyAll: [],
  unReadArticle: 0
};

const agreeDisagreeNextMap = {
  [HOME_ANSWER_AGREE_ACTION_TYPE]: {
    0: { tip: '已赞同', agreeStatus: 1 },
    1: { tip: '已取消赞同', agreeStatus: 0 },
    2: { tip: '已赞同', agreeStatus: 1 }
  },
  [HOME_ANSWER_DISAGREE_ACTION_TYPE]: {
    0: { tip: '已反对', agreeStatus: 2 },
    1: { tip: '已反对', agreeStatus: 2 },
    2: { tip: '已取消反对', agreeStatus: 0 }
  }
};

const model = createModel({
  state: homeModelState,
  namespace: 'homeModel',
  reducers: {
    updateHomeBannerLoading: (state, action: Tction<{ navKey: string; loading: boolean }>) => {
      const { navKey, loading } = action.payload;

      return produce(state, draftState => {
        draftState[navKey].banner.loading = loading;
      });
    },
    updateHomeBannerList: (state, action: Tction<{ navKey: string; list: BannerVO[] }>) => {
      const { navKey, list } = action.payload;

      return produce(state, draftState => {
        draftState[navKey].banner.list = list;
        draftState[navKey].banner.hasLoaded = true;
      });
    },

    resetHomeTabData: (state, action: Tction<{ navKey: string }>) => {
      const { navKey } = action.payload;

      return produce(state, draftState => {
        draftState[navKey].follow = { ...LIST_INITIAL };

        if (navKey === HOME_NAV_KEY_ARTICLE) {
          draftState[navKey].latest = { ...LIST_INITIAL };
          draftState[navKey].hot = { ...LIST_INITIAL };
          draftState[navKey].preRelease = { ...LIST_INITIAL };
          draftState[navKey].thematic = { ...LIST_INITIAL };
        } else {
          draftState[navKey].latestQuestion = { ...LIST_INITIAL };
          draftState[navKey].hotQuestion = { ...LIST_INITIAL };
          draftState[navKey].latestAnswer = { ...LIST_INITIAL };
          draftState[navKey].vote = { ...LIST_INITIAL };
        }
      });
    },
    updateHomeTabLoading: (
      state,
      action: Tction<{ navKey: string; tabIndex: string; loading: boolean }>
    ) => {
      const { navKey, tabIndex, loading } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].loading = loading;
      });
    },
    updateHomeTabHasLoaded: (
      state,
      action: Tction<{ navKey: string; tabIndex: string; hasLoaded: boolean }>
    ) => {
      const { navKey, tabIndex, hasLoaded } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].hasLoaded = hasLoaded;
      });
    },
    updateHomeTabIsEnded: (
      state,
      action: Tction<{ navKey: string; tabIndex: string; isEnded: boolean }>
    ) => {
      const { navKey, tabIndex, isEnded } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].isEnded = isEnded;
      });
    },
    updateHomeTabList: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        list: any[];
        pageNum?: number;
        total?: number;
        pageSize?: number;
      }>
    ) => {
      const { navKey, tabIndex, list, pageNum, total, pageSize = PAGE_SIZE } = action.payload;

      const appendData = list.map((item: any) => {
        if (navKey === HOME_NAV_KEY_ARTICLE && tabIndex !== HOME_TAB_KEY_THEMATIC) {
          item.id = item.articleId;
        }
        if (tabIndex === HOME_TAB_KEY_THEMATIC) {
          item.id === item.id;
        }
        if (tabIndex === HOME_TAB_KEY_LATEST_QUESTION || tabIndex === HOME_TAB_KEY_HOT_QUESTION) {
          item.id = item.questionId;
        }
        if (tabIndex === HOME_TAB_KEY_LATEST_ANSWER) {
          item.id = item.answerId;
        }

        if (tabIndex === HOME_TAB_KEY_VOTE) {
          item.id = item.voteQuestionId;
        }

        if (tabIndex === HOME_TAB_KEY_FOLLOW && item.idType === 'VOTE_QUESTION') {
          item.votePublishUser = {
            name: item.actionCommonInfo,
            username: item.actionCommonInfoId
          };
          item.voteQuestionTitle = item.title;
          item.voteQuestionSubContent = item.subContent;
          item.voteQuestionId = item.id;
          item.concerned = item.hasFollow;
        }

        item.isFollowing = false;
        item.isAgreeing = false;
        item.isDisagreeing = false;
        return item;
      });

      return produce(state, draftState => {
        draftState[navKey][tabIndex].pageNum = pageNum;
        draftState[navKey][tabIndex].pageSize = pageSize;
        draftState[navKey][tabIndex].total = total;
        draftState[navKey][tabIndex].list = [...appendData];
      });
    },
    /** 更改页号 */
    updateHomeTabListPage: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        pageNum: number;
        pageSize?: number;
      }>
    ) => {
      const { navKey, tabIndex, pageNum, pageSize = PAGE_SIZE } = action.payload;
      return produce(state, draftState => {
        draftState[navKey][tabIndex].pageNum = pageNum;
        draftState[navKey][tabIndex].pageSize = pageSize;
      });
    },
    updateHomeQuestionIsFollowing: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        index: number;
        questionId: number;
        isFollowing: boolean;
      }>
    ) => {
      const { navKey, tabIndex, index, questionId, isFollowing } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].list[index].isFollowing = isFollowing;
      });
    },
    /** 收藏切换 */
    updateHomeHasCollected: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        index: number;
        articleId: number;
        hasCollect: boolean;
      }>
    ) => {
      const { navKey, tabIndex, index, articleId, hasCollect } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].list[index].hasCollect = hasCollect;
      });
    },
    /** 预发布想看更新 */
    updateHomeWanted: (
      state,
      action: Tction<{
        index: number;
        count: number;
      }>
    ) => {
      const { index, count } = action.payload;

      return produce(state, draftState => {
        draftState['article']['preRelease'].list[index].interestCount = count;
      });
    },
    updateHomeVoteIsFollowing: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        index: number;
        isFollowing: boolean;
      }>
    ) => {
      const { navKey, tabIndex, index, isFollowing } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].list[index].isFollowing = isFollowing;
      });
    },
    updateHomeQuestionFollow: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        index: number;
        questionId: number;
        type: boolean;
      }>
    ) => {
      const { navKey, tabIndex, index, questionId, type } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].list[index].hasFollow = type;
      });
    },
    updateHomeVoteFollow: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        index: number;
        type: boolean;
      }>
    ) => {
      const { navKey, tabIndex, index, type } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].list[index].concerned = type;
      });
    },
    updateHomeAnswerIsAgreeingDisagreeing: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        index: number;
        isAgreeing?: boolean;
        isDisagreeing?: boolean;
      }>
    ) => {
      const { navKey, tabIndex, index, isAgreeing, isDisagreeing } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].list[index].isAgreeing = !!isAgreeing;
        draftState[navKey][tabIndex].list[index].isDisagreeing = !!isDisagreeing;
      });
    },
    updateHomeAnswerAgreeDisagree: (
      state,
      action: Tction<{
        navKey: string;
        tabIndex: string;
        index: number;
        agreeStatus: number;
        agreeCount: number;
        disagreeCount: number;
      }>
    ) => {
      const { navKey, tabIndex, index, agreeStatus, agreeCount, disagreeCount } = action.payload;

      return produce(state, draftState => {
        draftState[navKey][tabIndex].list[index].agreeStatus = agreeStatus;
        draftState[navKey][tabIndex].list[index].agreeCount = agreeCount;
        draftState[navKey][tabIndex].list[index].disagreeCount = disagreeCount;
      });
    },
    /**
     * @description 设置热门团队信息
     */
    setTeamList: (state, action: Tction<{ teamList: HotGroupOrTeamEntity[] }>): typeof state => {
      return {
        ...state,
        teamList: action.payload.teamList
      };
    },
    /**
     * @description 设置热门圈子信息
     */
    setGroupList: (state, action: Tction<{ groupList: HotGroupOrTeamEntity[] }>): typeof state => {
      return {
        ...state,
        groupList: action.payload.groupList
      };
    },
    /** 文章分类列表 */
    setClassifyAll: (state, action: Tction<{ classifyAll: ClassifyInfo[] }>): typeof state => {
      return {
        ...state,
        classifyAll: action.payload.classifyAll
      };
    },
    /** 最新文章未读数量 */
    setUnReadArticle: (state, action: Tction<{ unReadArticle: number }>): typeof state => {
      const { unReadArticle } = action.payload;
      return {
        ...state,
        unReadArticle
      };
    }
  },
  effects: {
    doGetHomeBanner: [
      function*({ tCall, tPut }, action: Tction<{ navKey: string }>): Iterator<{}, any, any> {
        const { navKey } = action.payload;
        let type = 1;

        if (navKey === HOME_NAV_KEY_ASK) {
          type = 2;
        }

        yield tPut(model.actions.updateHomeBannerLoading, {
          navKey,
          loading: true
        });

        const res: Utils.GetROA<typeof APIS.HomeApi.homeBannerUsingGet> = yield tCall(
          APIS.HomeApi.homeBannerUsingGet,
          {
            type
          }
        );

        yield tPut(model.actions.updateHomeBannerLoading, {
          navKey,
          loading: false
        });

        if (res.code === 0 && Array.isArray(res.result)) {
          yield tPut(model.actions.updateHomeBannerList, {
            navKey,
            list: res.result
          });
        }
      },
      {
        type: 'takeLatest'
      }
    ],
    doGetHomeFollow: [
      function*(
        { tCall, tPut, select },
        action: Tction<{ navKey: string; classifyId?: number }>
      ): Iterator<{}, any, any> {
        const { navKey, classifyId = 0 } = action.payload;
        const tabIndex = 'follow';

        const info = yield select((state: IRootState): ListPane<any> => state.home[navKey].follow);

        yield tPut(model.actions.updateHomeTabLoading, {
          navKey,
          tabIndex,
          loading: true
        });

        let res;

        if (navKey === HOME_NAV_KEY_ARTICLE) {
          res = yield tCall(APIS.HomeApi.homeFollowUsingGet, {
            pageSize: PAGE_SIZE,
            pageNum: info.pageNum + 1,
            classifyId: classifyId
          });
        } else {
          res = yield tCall(APIS.HomeApi.homeQuestionFollowerUsingGet, {
            pageSize: PAGE_SIZE,
            pageNum: info.pageNum + 1
          });
        }

        yield tPut(model.actions.updateHomeTabHasLoaded, {
          navKey,
          tabIndex,
          hasLoaded: true
        });
        yield tPut(model.actions.updateHomeTabLoading, {
          navKey,
          tabIndex,
          loading: false
        });

        const { code, result } = res;

        if (code === 0 && result && Array.isArray(result.list) && result.list.length > 0) {
          const { list, pageNum, total } = result;
          yield tPut(model.actions.updateHomeTabList, {
            navKey,
            tabIndex,
            pageNum,
            total,
            list
          });

          if (total && pageNum && Math.ceil(total / PAGE_SIZE) === pageNum) {
            yield tPut(model.actions.updateHomeTabIsEnded, {
              navKey,
              tabIndex,
              isEnded: true
            });
          }
        }
      },
      {
        type: 'takeEvery'
      }
    ],
    doGetHomeLatestAndHot: [
      function*(
        { tCall, tPut, select },
        action: Tction<{
          navKey: string;
          tabIndex: string;
          type: string;
          classifyId?: number;
          callBack?: () => void;
        }>
      ): Iterator<{}, any, any> {
        const { navKey, tabIndex, classifyId = 0, type, callBack } = action.payload;

        const info = yield select(
          (state: IRootState): ListPane<any> => state.home[navKey][tabIndex]
        );
        yield tPut(model.actions.updateHomeTabLoading, {
          navKey,
          tabIndex,
          loading: true
        });

        let res;

        if (navKey === HOME_NAV_KEY_ARTICLE && tabIndex !== HOME_TAB_KEY_THEMATIC) {
          res = yield tCall(APIS.HomeApi.homeArticlesUsingGet, {
            pageSize: PAGE_SIZE,
            pageNum: info.pageNum + 1,
            type,
            classifyId
          });
        }
        if (navKey === HOME_NAV_KEY_ARTICLE && tabIndex === HOME_TAB_KEY_THEMATIC) {
          res = yield tCall(APIS.SubjectApi.subjectsListUsingGet, {
            pageSize: THEMATIC_PAGE_SIZE,
            pageNum: info.pageNum + 1
          });
        }
        if (tabIndex === HOME_TAB_KEY_HOT_QUESTION) {
          res = yield tCall(APIS.HomeApi.homeQuestionsUsingGet, {
            pageSize: PAGE_SIZE,
            pageNum: info.pageNum + 1,
            type
          });
        }

        if (tabIndex === HOME_TAB_KEY_LATEST_QUESTION) {
          res = yield tCall(APIS.HomeApi.homeQuestionsUsingGet, {
            pageSize: PAGE_SIZE,
            pageNum: info.pageNum + 1,
            type
          });
        }

        if (tabIndex === HOME_TAB_KEY_LATEST_ANSWER) {
          res = yield tCall(APIS.HomeApi.homeAnswersUsingGet, {
            pageSize: PAGE_SIZE,
            pageNum: info.pageNum + 1
          });
        }

        if (tabIndex === HOME_TAB_KEY_VOTE) {
          res = yield tCall(APIS.VoteApi.voteListUsingGet, {
            pageSize: PAGE_SIZE,
            pageNum: info.pageNum + 1
          });
        }

        yield tPut(model.actions.updateHomeTabHasLoaded, {
          navKey,
          tabIndex,
          hasLoaded: true
        });
        yield tPut(model.actions.updateHomeTabLoading, {
          navKey,
          tabIndex,
          loading: false
        });

        const { code, result } = res;

        if (code === 0 && Array.isArray(result.list) && result.list.length > 0) {
          const { pageNum, total, list, pageSize } = result;
          if (tabIndex === HOME_TAB_KEY_LATEST) {
            callBack && callBack();
            // yield tPut(model.actions.setUnReadArticle, { unReadArticle: 0 });
          }
          yield tPut(model.actions.updateHomeTabList, {
            navKey,
            tabIndex,
            pageNum,
            total,
            list,
            pageSize
          });
          if (total && pageNum && Math.ceil(total / PAGE_SIZE) === pageNum) {
            yield tPut(model.actions.updateHomeTabIsEnded, {
              navKey,
              tabIndex,
              isEnded: true
            });
          }
        }
      },
      {
        type: 'takeEvery'
      }
    ],
    doFollowHomeQuestion: [
      function*(
        { tCall, tPut },
        action: Tction<{ tabIndex: string; questionId: number; index: number; type: boolean }>
      ): Iterator<{}, any, any> {
        const { tabIndex, questionId, type, index } = action.payload;

        yield tPut(model.actions.updateHomeQuestionIsFollowing, {
          navKey: HOME_NAV_KEY_ASK,
          tabIndex,
          index,
          questionId,
          isFollowing: true
        });

        const res: Utils.GetROA<typeof APIS.QuestionApi.questionQuestionIdCollectUsingPost> = yield tCall(
          APIS.QuestionApi.questionQuestionIdCollectUsingPost,
          {
            questionId,
            type
          }
        );

        yield tPut(model.actions.updateHomeQuestionIsFollowing, {
          navKey: HOME_NAV_KEY_ASK,
          tabIndex,
          index,
          questionId,
          isFollowing: false
        });

        if (res.code === 0) {
          yield tPut(model.actions.updateHomeQuestionFollow, {
            navKey: HOME_NAV_KEY_ASK,
            tabIndex,
            index,
            questionId,
            type
          });

          message.success(type ? '已关注' : '已取消关注');
        } else {
          message.error(`${res.message || NETWORK_ERROR_TIP}`);
        }
      },
      {
        type: 'takeLatest'
      }
    ],
    /** 文章或问答收藏 */
    doCollectHomeList: [
      function*(
        { tCall, tPut },
        action: Tction<{
          tabIndex: string;
          articleId: number;
          index: number;
          type: boolean;
        }>
      ): Iterator<{}, any, any> {
        const { tabIndex, articleId, type, index } = action.payload;
        let res: CommonResult = {};
        if (type) {
          res = yield tCall(APIS.UserApi.userCollectionArticleIdUsingPost, { articleId });
        } else {
          res = yield tCall(APIS.UserApi.userCollectionArticleIdCancelUsingPost, { articleId });
        }
        if (res.code === 0) {
          yield tPut(model.actions.updateHomeHasCollected, {
            navKey: HOME_NAV_KEY_ARTICLE,
            tabIndex,
            index,
            articleId,
            hasCollect: type
          });
          message.success(type ? '收藏成功' : '已成功取消收藏');
        } else {
          message.error(type ? '收藏失败' : '取消收藏失败');
        }
      },
      {
        type: 'takeLatest'
      }
    ],
    doFollowHomeVote: [
      function*(
        { tCall, tPut },
        action: Tction<{ tabIndex: string; questionId: number; index: number; type: boolean }>
      ): Iterator<{}, any, any> {
        const { tabIndex, questionId, type, index } = action.payload;

        yield tPut(model.actions.updateHomeVoteIsFollowing, {
          navKey: HOME_NAV_KEY_ASK,
          tabIndex,
          index,
          isFollowing: true
        });

        const res: Utils.GetROA<typeof APIS.VoteApi.voteFollowVoteQuestionIdUsingPost> = yield tCall(
          APIS.VoteApi.voteFollowVoteQuestionIdUsingPost,
          {
            voteQuestionId: questionId,
            type
          }
        );

        yield tPut(model.actions.updateHomeVoteIsFollowing, {
          navKey: HOME_NAV_KEY_ASK,
          tabIndex,
          index,
          isFollowing: false
        });

        if (res.code === 0) {
          yield tPut(model.actions.updateHomeVoteFollow, {
            navKey: HOME_NAV_KEY_ASK,
            tabIndex,
            index,
            type
          });

          message.success(type ? '已关注' : '已取消关注');
        } else {
          message.error(`${res.message || NETWORK_ERROR_TIP}`);
        }
      },
      {
        type: 'takeLatest'
      }
    ],
    doAgreeDisagreeHomeAnswer: [
      function*(
        { tCall, tPut },
        action: Tction<{
          tabIndex: string;
          answerId: number;
          index: number;
          clickedType: string;
          currentType: number;
        }>
      ): Iterator<{}, any, any> {
        const { tabIndex, answerId, index, clickedType, currentType } = action.payload;

        yield tPut(model.actions.updateHomeAnswerIsAgreeingDisagreeing, {
          navKey: HOME_NAV_KEY_ASK,
          tabIndex,
          index,
          [`is${upperFirst(clickedType)}ing`]: true
        });

        const res: Utils.GetROA<typeof APIS.AnswerApi.answerAnswerIdAgreeUsingPost> = yield tCall(
          APIS.AnswerApi.answerAnswerIdAgreeUsingPost,
          {
            answerId,
            type: agreeDisagreeNextMap[clickedType][currentType].agreeStatus
          }
        );

        yield tPut(model.actions.updateHomeAnswerIsAgreeingDisagreeing, {
          navKey: HOME_NAV_KEY_ASK,
          tabIndex,
          index,
          [`is${upperFirst(clickedType)}ing`]: false
        });

        if (res.code === 0 && res.result && Object.keys(res.result).length >= 2) {
          const { agreeCount = 0, disagreeCount = 0 } = res.result;

          yield tPut(model.actions.updateHomeAnswerAgreeDisagree, {
            navKey: HOME_NAV_KEY_ASK,
            tabIndex,
            index,
            agreeStatus: agreeDisagreeNextMap[clickedType][currentType].agreeStatus,
            agreeCount,
            disagreeCount
          });

          message.success(agreeDisagreeNextMap[clickedType][currentType].tip);
        } else {
          message.error(`${res.message || NETWORK_ERROR_TIP}`);
        }
      },
      {
        type: 'takeLatest'
      }
    ],
    /**
     * 更改页码
     */
    *changeTabListPage(
      { tPut },
      action: Tction<{
        navKey: string;
        tabKey: string;
        pageNum: number;
        classifyId?: number;
        pageSize?: number;
      }>
    ): Iterator<{}> {
      const { navKey, tabKey, pageNum, classifyId = 0, pageSize = PAGE_SIZE } = action.payload;
      let type: string;
      if (tabKey === HOME_TAB_KEY_HOT || tabKey === HOME_TAB_KEY_HOT_QUESTION) {
        type = 'HOT';
      } else if (tabKey === HOME_TAB_KEY_LATEST || tabKey === HOME_TAB_KEY_LATEST_QUESTION) {
        type = 'LATEST';
      } else {
        type = '';
      }

      if (tabKey === HOME_TAB_KEY_FOLLOW) {
        yield tPut(model.actions.doGetHomeFollow, { navKey, classifyId });
      } else {
        yield tPut(model.actions.doGetHomeLatestAndHot, {
          navKey,
          tabIndex: tabKey,
          type,
          classifyId
        });
      }
      yield tPut(model.actions.updateHomeTabListPage, {
        navKey,
        tabIndex: tabKey,
        pageNum: pageNum - 1,
        pageSize
      });
    },

    /**
     * @description 获取热门团队列表
     */
    *getTeamList({ tPut, tCall }): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.HomeApi.homeHotTeamsUsingGet> = yield tCall(
        APIS.HomeApi.homeHotTeamsUsingGet,
        { pageSize: 5, pageNum: 1 }
      );
      if (res.code === 0) {
        yield tPut(model.actions.setTeamList, {
          teamList: res.result || []
        });
      }
    },
    /**
     * @description  获取热门圈子列表
     */
    *getGroupList({ tPut, tCall }): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.HomeApi.homeHotGroupsUsingGet> = yield tCall(
        APIS.HomeApi.homeHotGroupsUsingGet,
        { pageSize: 5, pageNum: 1 }
      );
      if (res.code === 0) {
        yield tPut(model.actions.setGroupList, {
          groupList: res.result || []
        });
      }
    },

    /**
     * @description 获取文章分类列表
     */
    *getClassifyAll({ tPut, tCall }): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.ClassifyApi.classifyBaseAllUsingGet> = yield tCall(
        APIS.ClassifyApi.classifyBaseAllUsingGet
      );
      if (res.code === 0) {
        yield tPut(model.actions.setClassifyAll, { classifyAll: res.result || [] });
      }
    },
    /**
     * @description 获取最新文章未读数量
     */
    *getUnReadArticle(
      { tPut, tCall },
      action: Tction<{ callBack?: (res: CommonResult) => void }>
    ): Iterator<{}, any, any> {
      const { callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.HomeApi.homeArticlesUnreadCountUsingGet> = yield tCall(
        APIS.HomeApi.homeArticlesUnreadCountUsingGet
      );
      if (res.code === 0) {
        yield tPut(model.actions.setUnReadArticle, { unReadArticle: res.result || 0 });
        callBack && callBack(res);
      }
    },
    /**
     * @description 预发布想看
     */
    *wantToRead(
      { tPut, tCall },
      action: Tction<{
        params: ParamsarticleInterestBussinessIdUsingPost;
        index: number;
      }>
    ): Iterator<{}, any, any> {
      const { params, index } = action.payload;
      const res: Utils.GetROA<typeof APIS.ArticleApi.articleInterestBussinessIdUsingPost> = yield tCall(
        APIS.ArticleApi.articleInterestBussinessIdUsingPost,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.updateHomeWanted, {
          index,
          count: res.result || 0
        });
        message.success('已成功预约文章');
      } else {
        message.error(res.message);
      }
    },
    /** 预告 */
    *getPreRelease(
      { tPut, tCall },
      action: Tction<{ params: ParamshomeArticlesUsingGet; callBack?: (res: CommonResult) => void }>
    ): Iterator<{}, any, any> {
      const { callBack, params } = action.payload;
      const res: Utils.GetROA<typeof APIS.HomeApi.homeArticlesUsingGet> = yield tCall(
        APIS.HomeApi.homeArticlesUsingGet,
        params
      );
      if (res.code === 0) {
        callBack && callBack(res);
      }
    },
    /** 精选专题 */
    *getSeleted(
      { tPut, tCall },
      action: Tction<{ params: ParamssubjectsListUsingGet; callBack?: (res: CommonResult) => void }>
    ): Iterator<{}, any, any> {
      const { callBack, params } = action.payload;
      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsListUsingGet> = yield tCall(
        APIS.SubjectApi.subjectsListUsingGet,
        params
      );
      if (res.code === 0) {
        callBack && callBack(res);
      }
    }
  }
});

export default model;
